import React, { useEffect, useState } from "react";

interface UserRegistrationModalProps {
  isVisible: boolean;
  userData: {
    nombre: string;
    checkAt: string;
    status: string;
  } | null;
  onClose: () => void;
}

const UserRegistrationModal: React.FC<UserRegistrationModalProps> = ({
  isVisible,
  userData,
  onClose,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isVisible && userData) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
        setTimeout(onClose, 300);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, userData, onClose]);

  if (!isVisible || !userData) return null;

  console.log("UserRegistrationModal - isVisible:", isVisible);
  console.log("UserRegistrationModal - userData:", userData);

  const getStatusColor = () => {
    switch (userData.status) {
      case "Asistencia":
      case "Salida registrada":
        return "text-success";
      case "Retardo":
        return "text-warning";
      case "Fuera de horario":
        return "text-info";
      default:
        return "text-secondary";
    }
  };

  const getStatusIcon = () => {
    switch (userData.status) {
      case "Asistencia":
        return "fas fa-check-circle";
      case "Retardo":
        return "fas fa-clock";
      case "Salida registrada":
        return "fas fa-sign-out-alt";
      case "Fuera de horario":
        return "fas fa-exclamation-triangle";
      default:
        return "fas fa-user-check";
    }
  };

  const getStatusText = () => {
    switch (userData.status) {
      case "Asistencia":
        return "Asistencia registrada";
      case "Retardo":
        return "Retardo registrado";
      case "Salida registrada":
        return "Salida registrada";
      case "Fuera de horario":
        return "Registro fuera de horario";
      default:
        return "Registro completado";
    }
  };

  return (
    <>
      <div 
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{ 
          zIndex: 1050,
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(2px)"
        }}
        onClick={onClose}
      ></div>

      <div 
        className="position-fixed top-50 start-50 translate-middle"
        style={{ 
          zIndex: 1055,
          transform: isAnimating ? 'translate(-50%, -50%) scale(1)' : 'translate(-50%, -50%) scale(0.8)',
          transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          opacity: isAnimating ? 1 : 0
        }}
      >
        <div 
          className="card"
          style={{ 
            minWidth: "450px", 
            maxWidth: "550px",
            backgroundColor: "#ffffff",
            border: "none",
            borderRadius: "20px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3), 0 8px 25px rgba(0, 0, 0, 0.2)",
            overflow: "hidden"
          }}
        >
          <div 
            className="card-body p-0"
            style={{ backgroundColor: "#ffffff" }}
          >
            
            <div className="p-4">
              <div 
                className="rounded-3 p-4 mb-4"
                style={{ 
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #e9ecef"
                }}
              >
                <div className="d-flex align-items-center">
                  <div 
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ 
                      width: "50px", 
                      height: "50px",
                      backgroundColor: "#f8f9fa",
                      border: "2px solid #e9ecef"
                    }}
                  >
                    <i className="fas fa-user" style={{ color: "#FA0A0A" }}></i>
                  </div>
                  <div>
                    <h6 className="mb-1 fw-bold" style={{ color: "#2c3e50" }}>{userData.nombre}</h6>
                    <small style={{ color: "#6c757d" }}>Empleado registrado</small>
                  </div>
                </div>
              </div>

              <div className="row g-3 mb-4">
                <div className="col-6">
                  <div 
                    className="rounded-3 p-3 text-center"
                    style={{ 
                      backgroundColor: "#e3f2fd",
                      border: "1px solid #bbdefb"
                    }}
                  >
                    <i className="fas fa-clock mb-2" style={{ color: "#1976d2", fontSize: "1.5rem" }}></i>
                    <div className="fw-bold" style={{ color: "#1565c0" }}>{userData.checkAt}</div>
                    <small style={{ color: "#1976d2" }}>Hora de registro</small>
                  </div>
                </div>
                <div className="col-6">
                  <div 
                    className="rounded-3 p-3 text-center"
                    style={{ 
                      backgroundColor: "#e8f5e8",
                      border: "1px solid #c8e6c9"
                    }}
                  >
                    <i className={`${getStatusIcon()} mb-2 ${getStatusColor()}`} style={{ fontSize: "1.5rem" }}></i>
                    <div className="fw-bold" style={{ color: "#2e7d32" }}>{userData.status}</div>
                    <small style={{ color: "#388e3c" }}>Estado</small>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <div 
                  className="rounded-pill"
                  style={{ 
                    height: "6px",
                    backgroundColor: "#e9ecef",
                    overflow: "hidden"
                  }}
                >
                  <div 
                    className="h-100"
                    style={{ 
                      background: "linear-gradient(90deg, #FA0A0A 0%, #F7B917 100%)",
                      width: "100%",
                      animation: "progressShrink 5s linear forwards"
                    }}
                  ></div>
                </div>
                <small style={{ color: "#6c757d" }}>Se cerrará automáticamente</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes progressShrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </>
  );
};

export default UserRegistrationModal; 